import React, { useState } from 'react';
import { uploadInvoiceForPurchaseOrder } from 'services';
import { showError } from 'utils';
import styles from './index.module.scss';
import FileUploadComponent from 'components/FileUploadComponent/index';

const UploadInvoiceModal = props => {
  const { poId, onSuccess, toggleModal } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [invoiceId, setInvoiceId] = useState<string>('');
  const [invoice, setInvoice] = useState<string | File>();

  const uploadInvoice = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    setLoading(true);
    if (!invoiceId) {
      showError('Invoice ID is required');
      setLoading(false);
      return;
    }
    if (!invoice) {
      showError('Invoice File is required');
      setLoading(false);
      return;
    }
    const data = {
      id: poId,
      invoiceId,
      invoice,
    };

    try {
      await uploadInvoiceForPurchaseOrder(data);
      await onSuccess();
      toggleModal();
    } catch (e) {
      showError(e);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={uploadInvoice} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Purchase Order</div>
            <div className={styles['modal-title']}>Upload Invoice</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div>
            <div className={styles['label']}>Invoice ID</div>
            <input
              className={'form-control'}
              onChange={e => setInvoiceId(e.target.value)}
            />
          </div>
          <div className={'mt-4'}>
            <div className={styles['label']}>Invoice Image</div>
            <div className={styles['image-container']}>
              <FileUploadComponent
                entityId={''}
                uploadAPI={(id, file) => setInvoice(file)}
              />
            </div>
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type={'submit'}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default UploadInvoiceModal;
